"use client";
import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "../../components/LandingPage/Guarantee/Guarantee.module.scss";

export interface dataProps {
	icon: string;
	title: string;
	text: string;
}

const useGuarantee = () => {
	const cardData: dataProps[] = [
		{
			icon: "/svgs/speed.svg",
			title: "Prompt Delivery",
			text: "We understand that time is of the essence, so we guarantee prompt and reliable delivery of all orders, no matter how large or small.",
		},
		{
			icon: "/svgs/price.svg",
			title: "Competitive Prices",
			text: " We believe in offering the best value for money, which is why we guarantee competitive prices on all of our products and services.",
		},
		{
			icon: "/svgs/return.svg",
			title: "Easy Returns",
			text: "If for any reason you are not completely satisfied with your purchase, we guarantee an easy and hassle-free return process.",
		},
	];
	const topSectionRef = useRef<HTMLDivElement>(null);
	const firstCardRef = useRef<HTMLDivElement>(null);
	const secondCardRef = useRef<HTMLDivElement>(null);
	const thirdCardRef = useRef<HTMLDivElement>(null);
	const fourthCardRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const isMobile = () => window.innerWidth <= 650;
		const topSection = topSectionRef.current;
		const firstCard = firstCardRef.current;
		const secondCard = secondCardRef.current;
		const thirdCard = thirdCardRef.current;
		const fourthCard = fourthCardRef.current;

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(styles.visible);
						// observer.unobserve(entry.target);
					} else {
						entry.target.classList.remove(styles.visible);
					}
				});
			},
			{
				root: null,
				rootMargin: "0px",
				threshold: 0.15,
			}
		);

		const cardObserver = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(styles.visible);
						// cardObserver.unobserve(entry.target);
					} else {
						entry.target.classList.remove(styles.visible);
					}
				});
			},
			{
				root: null,
				threshold: 0.04,
				rootMargin: "0px",
			}
		);

		const setupObservers = () => {
			const mobile = isMobile();
			if (mobile) {
				if (topSection) observer.unobserve(topSection);
				if (firstCard) cardObserver.observe(firstCard);
				if (secondCard) cardObserver.observe(secondCard);
				if (thirdCard) cardObserver.observe(thirdCard);
				if (fourthCard) cardObserver.observe(fourthCard);
			} else {
				if (firstCard) cardObserver.unobserve(firstCard);
				if (secondCard) cardObserver.unobserve(secondCard);
				if (thirdCard) cardObserver.unobserve(thirdCard);
				if (fourthCard) cardObserver.observe(fourthCard);
				if (topSection) observer.observe(topSection);
			}
		};

		setupObservers();

		window.addEventListener("resize", setupObservers);

		return () => {
			window.removeEventListener("resize", setupObservers);
			if (isMobile()) {
				if (firstCard) cardObserver.unobserve(firstCard);
				if (secondCard) cardObserver.unobserve(secondCard);
				if (thirdCard) cardObserver.unobserve(thirdCard);
				if (fourthCard) cardObserver.unobserve(fourthCard);
				cardObserver.disconnect();
			} else {
				if (topSection) observer.unobserve(topSection);
				observer.disconnect();
			}
		};
	}, []);

	// useEffect(() => {
	// 	// gsap.registerPlugin(ScrollTrigger);
	// 	const isMobile = () => window.innerWidth <= 650;
	// 	const cards = gsap.utils.toArray(`.${styles.card}`);
	// 	const topSection = topSectionRef.current;
	// 	cards.forEach((card: any, index: number) => {
	// 		gsap.to(card,
	// 			{
	// 				opacity: 1,
	// 				y: 0,
	// 				duration: 0.4,
	// 				ease: "easeOut",
	// 				stagger: 0.2,
	// 				scrollTrigger: {
	// 					trigger: card,
	//                  start: "top 10%",
	// 					toggleActions: "restart none reverse none",
	// 					onEnter: () => console.log("Entering section"),
	// 					onEnterBack: () => console.log("Entering back section"),
	// 				},
	// 			}
	// 		);
	// 	});
	// }, []);

	return {
		topSectionRef,
		firstCardRef,
		secondCardRef,
		thirdCardRef,
		fourthCardRef,
		cardData,
	};
};

export default useGuarantee;
